import React from "react";
import { Crown } from "lucide-react";

export function Logo({ className = "", showTagline = false }) {
  return (
    <div className={`flex flex-col items-center leading-none ${className}`} data-testid="brand-logo">
      <Crown className="text-gold mb-0.5" size={18} strokeWidth={1.5} />
      <div className="font-serif font-extrabold tracking-tight text-cream text-lg sm:text-xl">
        OVERFLOW
      </div>
      <div className="text-gold text-[9px] sm:text-[10px] tracking-[0.35em] font-semibold">
        POPCORN CO.
      </div>
      {showTagline && (
        <div className="text-gold/80 text-[9px] tracking-[0.25em] mt-1 uppercase">
          Gourmet Flavor · Overflowing Joy
        </div>
      )}
    </div>
  );
}
